<template>
  <div>
    <section>
      <div class="flex flex-col px-4">
        <h4
          class="font-bold text-grey-darkest text-4xl"
          v-text="`Total: ${baseTotal}`"
        />
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'RevenueProjectionSummary',
  computed: {
    ...mapState({
      revenueProjection: state => state.payments.revenueProjection,
    }),
    baseTotal() {
      return this.revenueProjection?.total ? `$${(this.revenueProjection.total / 100).toFixed(2)}` : ''
    },
  },
}
</script>
